let TouchHover = function (el) {
    this.$el = $(el);
    this.$anchors = this.$el.find(this.$el.data('anchorSelector') || '> li > a');
    this.attributes = {
        targetSelector: this.$el.data('targetSelector') || '[data-touchTarget]',
        clickedElement: document.body
    };

    if (Modernizr.touch) {
        this.initialize();
    }
};

TouchHover.prototype.initialize = function () {
    this.attachEvents();

    return this;
};

TouchHover.prototype.attachEvents = function () {
    let self = this;
    this.$anchors.on('click', function (e) {
        let $previousElement = self.attributes.clickedElement;
        if ($previousElement !== this) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
        self.attributes.clickedElement = this;
    });
};

export default TouchHover;
